<template>
  <AppMenu></AppMenu>
  <RouterView></RouterView>
  <KeyboardPopover v-if="keyboardPopoverEnabled"></KeyboardPopover>
</template>

<script setup>
import AppMenu from "./AppMenu.vue";
import KeyboardPopover from "./KeyboardPopover.vue";
const keyboardPopoverEnabled = Boolean(window.chrome?.webview);
</script>

<style scoped>
.app-header {
  padding: 2px;
  text-align: center;
  font-size: large;
  background: #0063B1;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.navbar {
  display: flex;
  gap: 5px;
}
.navbar .p-dropdown {
  flex-grow: 1;
  flex-basis: 0;
}

</style>